import React from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";

const SupportPolicy = () => {
  return (
    <>
      <Navbar />

      {/* Page Header */}
      <div style={styles.header}>
        <div style={styles.container}>
          <h1 style={styles.title}>Support Policy Page</h1>
          <div style={styles.breadcrumb}>
            Home / <span style={styles.active}>“Support Policy”</span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div style={styles.contentWrapper}>
        <div style={styles.container}>
          <p>At Z1 Technology and Trade, we are committed to providing high-quality support and maintenance services for both home and office appliances. Our dedicated service team is ready to assist you with any issues or repairs. Please review our support policy to understand the services we offer and how you can access them.</p>
          <h4><strong>1. Home Appliances Support</strong></h4>

          <p>For <b>home appliances</b> such as refrigerators, televisions, washing machines, and more, Z1 Technology provides in-home repair services to ensure that your appliances are maintained and fixed conveniently at your residence.</p>

          <Section
            title="Services Provided:"
            list={[
              "Repair and maintenance of refrigerators, TVs, washing machines, microwaves, and other home appliances.",
              "Qualified technicians will visit your home to assess and repair any issues.",
            ]}
          />

          <Section
            title="Service Availability:"
            list={[
              "Available in Butwal, Bhairahwa, Kapilvastu, and surrounding areas.",
              "Appointments can be scheduled by contacting our support team via [Insert Contact Information].",
            ]}
          />

          <Section
            title="Service Process:"
            list={[
              "Once a service request is made, a technician will contact you to schedule an appointment at your convenience.",
              "Our technicians will diagnose the issue and provide a service quote before proceeding with repairs.",
              "For warranty-covered products, repair services will be free of charge if the issue is covered by the warranty terms.",
            ]}
          />

          <h4><strong>2. Office Appliances Support</strong></h4>

          <p>For <b>office appliances</b> like computers, laptops, printers, and other IT equipment, Z1 Technology offers on-site support and maintenance services to ensure your business runs smoothly without interruptions.</p>

          <Section
            title="Services Provided:"
            list={[
              "On-site troubleshooting and repair of office equipment such as computers, laptops, printers, scanners, and networking devices.",
              "Preventive maintenance services to keep your office appliances functioning efficiently.",
            ]}
          />

          <Section
            title="Service Availability:"
            list={[
              "Available across Nepal for businesses, with priority support in <b>Butwal, Bhairahwa, Kapilvastu,</b> and surrounding regions.",
              "Emergency support can be arranged by contacting our support team directly.",
            ]}
          />

          <Section
            title="Service Process:"
            list={[
              "You can schedule an on-site support visit by reaching out to our support team.",
              "Our technicians will arrive at your location and conduct a thorough check-up, offering repair services or recommending replacement parts if necessary.",
              "We also offer Annual Maintenance Contracts (AMC) for businesses to ensure ongoing support and regular check-ups.",
            ]}
          />

          <h4><strong>3. General Support Policies</strong></h4>

          <p>For <b>office appliances</b> like computers, laptops, printers, and other IT equipment, Z1 Technology offers on-site support and maintenance services to ensure your business runs smoothly without interruptions.</p>

          <Section
            title="Response Time:"
            list={[
              "We aim to respond to all support requests within 24 hours of receiving the request. However, response times may vary depending on your location and the nature of the issue.",
            ]}
          />

          <Section
            title="Warranty Coverage:"
            list={[
              "For products under warranty, repairs are covered if the issue is deemed to be a manufacturing defect or a part failure under normal usage. Physical damage or misuse may not be covered.",
              "For non-warranty products, our team will provide a cost estimate before proceeding with repairs.",
            ]}
          />

          <Section
            title="Spare Parts:"
            list={[
              "In cases where spare parts are required for repair, we will notify you of the expected delivery time and costs. Only genuine or certified parts will be used for replacements.",
            ]}
          />

          <Section
            title="Payment:"
            list={[
              "After the completion of repair services, payment can be made via cash, card, or online payment options. For AMC clients, services will be included as part of the contract.",
            ]}
          />

          <Section title="4. How to Contact Us for Support">
            <p>
              If you need assistance with any of your home or office appliances, you can reach our support team using the following details:
            </p>

            <p style={{ marginTop: "16px" }}>
              <strong>Z1 Technology & Trade Pvt. Ltd.</strong><br />
              Siddharthanagar-12, Bhairahawa, Lumbini, Nepal<br />
              Email: z1techbhw@gmail.com<br />
              Phone: 071590132, 9857050123
            </p>
          </Section>
        </div>
      </div>

      <Footer />
    </>
  );
};

const Section = ({ title, text, list, children }) => (
  <div style={styles.section}>
    <h3 style={styles.sectionTitle}>{title}</h3>
    {text && <p>{text}</p>}
    {list && (
      <ul>
        {list.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    )}
    {children}
  </div>
);

const styles = {
  header: {
    padding: "40px 0",
    background: "#ffffff",
    borderBottom: "1px solid #e5e7eb",
  },
  container: {
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "0 16px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "700",
    marginBottom: "6px",
  },
  breadcrumb: {
    fontSize: "14px",
    color: "#6b7280",
  },
  active: {
    color: "#2563eb",
  },
  contentWrapper: {
    padding: "40px 0",
    background: "#ffffff",
  },
  section: {
    marginTop: "28px",
  },
  sectionTitle: {
    fontSize: "18px",
    fontWeight: "700",
    marginBottom: "8px",
  },
};

export default SupportPolicy;
